<template>
  <CustomModal v-if="open" @close="$emit('close')">
    <template v-slot:body>
      <div class="grid items-center grid-cols-1 row-gap-8">
        <div class="text-xl font-bold text-text leading-tight mr-10">{{ $t('createGroupTitle') }}</div>
        <BaseInput v-model.trim="$v.account_group_title.$model"
                   :label="$t('createInputLabel')"
                   class="col-span-2"
                   :class="{'--error':$v.account_group_title.$error }">
          <template v-slot:errors="">
            <div class="error" v-if="!$v.account_group_title.required">{{ $t('errors.required') }}</div>
          </template>
        </BaseInput>
        <BaseButton theme="red" @click="createGroup" :loading="submitted">
          {{ $t('createGroupBtn') }}
        </BaseButton>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import {mapActions, mapState} from "vuex";
import CustomModal from "@/components/UI/modals/CustomModal";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseButton from "@/components/UI/BaseButton";
import {decimal, maxLength, required} from "vuelidate/lib/validators";

export default {
  name: "AccountGroupAddModal",
  components: {
    BaseButton,
    BaseInput,
    CustomModal,
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      account_group_title: '',
      submitted: false
    }
  },
  validations: {
    account_group_title: {
      required
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/accounts', ['account_groups']),
  },
  methods: {
    ...mapActions('space/accounts', ['getAccountGroups', 'createAccountGroup']),
    createGroup() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let group_data = {
          space_id: this.current_space.data.id,
          title: this.account_group_title,
          order: this.account_groups.data.length
        };
        this.createAccountGroup(group_data).then(res => {
          if (res.body.success) {
            this.getAccountGroups();
            this.$emit('created', res.body.data);
            this.account_group_title = '';
            this.$toasted.success('Группа счета создана')
          } else {
            console.log(res)
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.submitted = false;
        });
      } else {
        this.$toasted.error('Проверьте поля')
        this.submitted = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        createGroupTitle: 'Create group for accounts',
        createInputLabel: 'Name your group',
        createGroupBtn: 'Create',
      },
      ru: {
        createGroupTitle: 'Создать группу для счетов',
        createInputLabel: 'Название группы',
        createGroupBtn: 'Создать',
      }
    }
  }
}
</script>
